export default {"src":"/login-app/[GIT_HASH]/_next/static/media/sso.352d6193.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};